import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl} from "@angular/forms";

@Component({
  selector: 'app-report-day-selector',
  templateUrl: './report-day-selector.component.html',
  styleUrls: ['./report-day-selector.component.scss']
})
export class ReportDaySelectorComponent implements OnInit {
  dateControl = new FormControl<Date | null>(new Date()); // Initialize with today's date
  @Output() public dateChanged = new EventEmitter<Date | null>(); // Event emitter for date changes

  ngOnInit(): void {
    this.dateControl.valueChanges.subscribe(newDate => {
      this.dateChanged.emit(newDate); // Emit the new date whenever it changes
    });
  }

  /**
   * Sets the dateControl value to the previous day.
   */
  goToPreviousDay(): void {
    const currentDate = this.dateControl.value || new Date(); // Use current date if null
    const previousDate = new Date(currentDate);
    previousDate.setDate(currentDate.getDate() - 1);
    this.dateControl.setValue(previousDate);
  }

  /**
   * Sets the dateControl value to the next day.
   */
  goToNextDay(): void {
    const currentDate = this.dateControl.value || new Date(); // Use current date if null
    const nextDate = new Date(currentDate);
    nextDate.setDate(currentDate.getDate() + 1);
    this.dateControl.setValue(nextDate);
  }


}
